<micro-select-combo #sel
              placeholder="Alarm Grid"
              routerBase="alarmGrids"
              [mode]="mode"
              [(id)]="alarmGridId"
              (idChange)="change($event)"
              [options]="options"
              [required]="required"
              [disabled]="disabled"
>
</micro-select-combo>
